export * from './simple-layout.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/containers/simple-layout/index.ts